import React from 'react';
import Banner from '../Banner/Banner';
import Contactme from '../Contactme/Contactme';




import Services from '../Services/Services';

const Home = () => {
    return (
        <div>


        <>
            <Banner></Banner>
            <Services></Services>
            <Contactme></Contactme>
        </>

        </div>
    );
};

export default Home;